export default __webpack_public_path__ + "static/skull_w.6bf3043806bb8176885fd206b115a4a0.svg";